import { NavLink } from 'react-router-dom';
import { DexControlsProvider, useDexPress } from './dexControls';

function ControlPad() {
  const press = useDexPress();
  return (
    <div className="controls">
      <div className="dpad" role="group" aria-label="Directional pad">
        <button className="pad up" type="button" aria-label="Up" onClick={() => press('onUp')}>▲</button>
        <button className="pad left" type="button" aria-label="Left" onClick={() => press('onLeft')}>◀</button>
        <button className="pad right" type="button" aria-label="Right" onClick={() => press('onRight')}>▶</button>
        <button className="pad down" type="button" aria-label="Down" onClick={() => press('onDown')}>▼</button>
      </div>
      <div className="ab" role="group" aria-label="Action buttons">
        <button className="btn-b" type="button" aria-label="B, back" onClick={() => press('onB')}>B</button>
        <button className="btn-a" type="button" aria-label="A, confirm" onClick={() => press('onA')}>A</button>
      </div>
    </div>
  );
}

function AppShell({ children }) {
  return (
    <DexControlsProvider>
      <div className="device">
        <a className="skip-link" href="#screen">Skip to screen</a>
        <div className="device-body">
          <div className="side-rail">
            <div className="lens" aria-hidden="true">
              <span className="lens-ring">
                <span className="lens-glass" />
              </span>
            </div>
            <div className="lights" aria-hidden="true">
              <span className="light light-red" />
              <span className="light light-yellow" />
              <span className="light light-green" />
            </div>
          </div>
          <div className="hinge" aria-hidden="true" />
          <div className="device-main">
            <header className="device-header">
              <div className="brand-block">
                <img className="brand-logo" src={`${process.env.PUBLIC_URL}/logo.svg`} alt="Poke-Blunder" />
                <p className="kicker">Unit 09</p>
              </div>
              <nav className="dex-nav" aria-label="Poke-Blunder">
                <NavLink to="/" end>Dex</NavLink>
                <NavLink to="/compare">Compare</NavLink>
                <NavLink to="/meta">Meta</NavLink>
              </nav>
            </header>
            <div className="screen" id="screen" tabIndex={-1}>
              <main id="main">{children}</main>
            </div>
            <ControlPad />
            <p className="pad-hint">Arrows move the selection. A confirms. B goes back.</p>
          </div>
        </div>
      </div>
    </DexControlsProvider>
  );
}

export default AppShell;
